import { StreamTypes } from 'store/player/actions.types';

import getStartoverUrl from 'services/data-manager/get-startover-url';
import getGuardTimeSchedule from 'services/data-manager/parsing/utils/getGuardTimeSchedule.ts';
import { VideoItem } from 'services/data-manager/types';

function parseVideoItemForSO(
    videoItem: VideoItem,
    sourceConfig?: VideoItem['sourceConfig'],
): VideoItem {
    const { startTime, endTime, duration } = getGuardTimeSchedule(videoItem);

    return {
        ...videoItem,
        startTime,
        endTime,
        duration,
        sourceConfig,
        playbackUrls: videoItem.playbackUrls.map((playbackUrlConfig) =>
            playbackUrlConfig.type === StreamTypes.startover
                ? {
                      ...playbackUrlConfig,
                      url: getStartoverUrl(
                          playbackUrlConfig.url,
                          startTime,
                          endTime,
                      ),
                  }
                : playbackUrlConfig,
        ),
    };
}

export default parseVideoItemForSO;
